import { OptionsApi } from '@core/swagger-client';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/upcoming')({
    loader: async ({ context }) => {
        const upcoming = context.queryClient.ensureQueryData(OptionsApi.webinars.getUpcoming({ refetchInterval: 60_000, staleTime: 60_000 }));
        await Promise.all([upcoming]);
        return {
            upcoming: await upcoming
        };
    }
});
